// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HxmRGxNHaqsMoTAcAd9XDw\\=\\={display:flex;width:100%;height:8rem;align-items:center;justify-content:center}", "",{"version":3,"sources":["webpack://./src/blocks/Checkout/AutoFillShippingInfoStep/AutoFillShippingInfoStep.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,UAAA,CACA,WAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".spinner-container {\n  display: flex;\n  width: 100%;\n  height: 8rem;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner-container": "HxmRGxNHaqsMoTAcAd9XDw=="
};
export default ___CSS_LOADER_EXPORT___;
